import { nextSingleSelectValue } from './SingleSelect';

/**
 * The selection callback contract shared by both platform implementations.
 * Only a consumer that opts into `allowDeselect` can receive `null`, so every
 * plain single-select keeps a `(value: string) => void` callback.
 */
export type SingleSelectSelection =
  | { allowDeselect?: false; onSelect?: (value: string) => void }
  | { allowDeselect: true; onSelect?: (value: string | null) => void };

/**
 * Resolve an option press into the value the consumer should receive: the
 * pressed option, or `null` when an `allowDeselect` list's selected option is
 * pressed again. Returns `undefined` when there is no callback to call.
 */
export function singleSelectPressHandler(
  selection: SingleSelectSelection,
  current: string | null | undefined,
): ((pressed: string) => void) | undefined {
  if (selection.allowDeselect) {
    const { onSelect } = selection;
    return onSelect && ((pressed) => onSelect(nextSingleSelectValue(current, pressed, true)));
  }
  const { onSelect } = selection;
  return onSelect && ((pressed) => onSelect(pressed));
}
